import { render, staticRenderFns } from "./SmplEditAppr.vue?vue&type=template&id=e5edc948&scoped=true&"
import script from "./SmplEditAppr.vue?vue&type=script&lang=js&"
export * from "./SmplEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5edc948",
  null
  
)

export default component.exports